import classes from './mission.module.css';

const TESTS = [
    {
        n: '01',
        title: 'Raise what the student is actually doing.',
        body: (
            <>
                Not what they watched. What they <em>attempted</em> — where they slowed
                down, what they crossed out, which second method they reached for when the
                first one stalled. A child learns math by doing math. Every tool we build
                is judged on one question: does it put more real solving into the hour?
            </>
        ),
    },
    {
        n: '02',
        title: 'Give the teacher back the hour.',
        body: (
            <>
                A tutor carries five jobs at once — being engaging, building the
                relationship, preparing the right material, teaching it, then marking and
                analysing it afterward. The first two are where the judgement lives, and no
                tool will ever do them. The other three are the price paid to get there.
                <em> We pay that price so the teacher doesn't have to.</em>
            </>
        ),
    },
];

const Mission = () => {
    return (
        <section id="mission" className={classes.section} aria-labelledby="mission-title">
            <div className={classes.inner}>
                <div className={classes.head}>
                    <p className="eyebrow">Our mission</p>
                    <h2 id="mission-title" className={classes.title}>
                        Technology earns its place in a math education only when it does one
                        of two things.
                    </h2>
                </div>

                <ol className={classes.tests}>
                    {TESTS.map((t) => (
                        <li key={t.n} className={classes.test}>
                            <span className={classes.n} aria-hidden="true">
                                {t.n}
                            </span>
                            <h3 className={classes.testTitle}>{t.title}</h3>
                            <p className={classes.testBody}>{t.body}</p>
                        </li>
                    ))}
                </ol>

                <p className={classes.coda}>
                    Anything that fails both tests, we don't ship — however good the demo
                    looks.
                </p>
            </div>
        </section>
    );
};

export default Mission;
